import { Component, forwardRef, Input, Output, EventEmitter } from '@angular/core';
import { SliderTickRenderedEventArgs } from '@syncfusion/ej2-angular-inputs';

@Component({
  selector: 'app-slider-sf',
  templateUrl: './slider-sf.component.html',
  styleUrls: ['./slider-sf.component.scss'],
})
export class SliderSfComponent {
  
  @Input() formControl: any;
  @Input() tooltip: Object = { placement: 'Before', isVisible: false, showOn: 'Always' };

  @Input() value: number;
  @Input() min: number;
  @Input() max: number;
  @Input() largeStep: any = 1;
  @Input() remarks: any;

  public slider_ticks: Object = { placement: 'Both', largeStep:  this.largeStep};
  
  @Output() valueChanged = new EventEmitter();

  onSliderChange(event: any) {
    this.value = event.value;
    this.onChange(this.value);
    this.emitValue(this.value);
  }

  public renderedTicks(args: SliderTickRenderedEventArgs) {
    let li: any = args.ticksWrapper.getElementsByClassName('e-large');
    for (let i: number = 0; i < li.length; ++i) {
      if (i < this.remarks.length) {
        (li[i].querySelectorAll('.e-tick-both')[1] as HTMLElement).innerText =
          this.remarks[i];
      }
    }

    if (li.length > 0 && this.remarks.length >= li.length) {
      let lastIndex = li.length - 1;
      (
        li[lastIndex].querySelectorAll('.e-tick-both')[1] as HTMLElement
      ).innerText = this.remarks[this.remarks.length - 1];
    }
  }

  emitValue(value: any): void {
    this.valueChanged.emit(value);
  }

  onChange = (value: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}

